import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import axios from "axios";
import VueAxios from "vue-axios";

import './assets/styles/style.css'
import '../public/fonts/helveticaNeueCyr/helveticaNeueCyr.css'

import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core'
import fontawesomeicons from './fontawesomeicons'
fontAwesomeLibrary.add(fontawesomeicons)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

import { ACCOUNT_INFO } from './store/actions.type'

Vue.use(VueAxios, axios);

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import AllRoutes from "./routes/all.routes"
import { TOKEN_OUT_OF_DATE } from "./store/mutations.type"

import VModal from "vue-js-modal"
Vue.use(VModal, { dialog: true })

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

import Draggable from 'vuedraggable'
Vue.component('draggable', Draggable)

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyDd0HtYULxdXkMofy_bIVljxgz-NcNJEB8'
	},
	installComponents: true,
});

import VAnimateCss from 'v-animate-css'
Vue.use(VAnimateCss)

import { Sketch } from 'vue-color'
Vue.component('sketch-picker', Sketch)

var vm = new Vue({
    store: require("./store/index").default,
    router: require("./router").default,
    render: h => h(App),
    created: function () {

        var self = this;

        //Отслеживание NotAuthorized ответов сервера и редирект на страницу логина
        axios.interceptors.response.use(undefined, function (err) {
            return new Promise(function () {
                if (err.response.status === 401 || err.response === undefined) {
                    self.$store.commit(TOKEN_OUT_OF_DATE);
                    self.$router.push(AllRoutes.Account.Login);
                }
                else
                    throw err;
            });
        });

        if (this.$store.getters.isAuthenticated)
            this.$store.dispatch(ACCOUNT_INFO);
    }
}).$mount('#app')

export default vm